module.exports = __webpack_public_path__ + "static/media/attendance-queda-blowbubble-sound.a77d6f18.mp3";